import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import { FixedSizeList } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';

import {
  SET_CUSTOMER,
  CLOSE_DLG_CUSTOMER_LIST,
  selectDialogCustomerList,
} from './reducer';

import { reqCustomers, searchCustomers } from './api';
import SearchInputBox from '../common/components/SearchInputBox';

// 한 번에 요청할 item tn
const PER_PAGE = 30;

const CustomerListDialog = () => {
  const dispatch = useDispatch();

  const { open } = useSelector(selectDialogCustomerList);

  const [items, setItems] = useState([]);
  const [itemCount, setItemCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const isItemLoaded = (index) => {
    return items.length === itemCount || index < items.length;
  };

  const loadMore = async (startIndex, stopIndex) => {
    console.log('loadmore...');
    if (loading || startIndex >= itemCount) return;

    try {
      setLoading(true);

      // load next page
      const nextPage = Math.ceil(items.length / PER_PAGE) + 1;
      const { total, data } = await reqCustomers(nextPage, PER_PAGE);

      // update items, itemCount
      setItems(items.concat(data));
      setItemCount(total);

      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
      setError(err);
    }
  };

  const handleEnter = async () => {
    // initialize
    setItems([]);
    setItemCount(1);
  };

  const handleClose = () => {
    dispatch({ type: CLOSE_DLG_CUSTOMER_LIST });
  };

  const handleClick = (index) => {
    dispatch({
      type: SET_CUSTOMER,
      payload: {
        customer: {
          id: items[index].id,
          name: items[index].name,
        },
      },
    });

    dispatch({ type: CLOSE_DLG_CUSTOMER_LIST });
  };

  const pressEnter = async (word) => {
    try {
      setLoading(true);
      const { total, data } = await searchCustomers(word);

      // update items, itemCount
      setItems(data);
      setItemCount(total);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const clickClear = async () => {
    try {
      setLoading(true);
      const { total, data } = await reqCustomers(1, PER_PAGE);

      // update items, itemCount
      setItems(data);
      setItemCount(total);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onEnter={handleEnter}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">고객사 선택</DialogTitle>

      <SearchInputBox onPressEnter={pressEnter} onClickClear={clickClear} />

      <InfiniteLoader
        isItemLoaded={isItemLoaded}
        loadMoreItems={loadMore}
        itemCount={itemCount}
      >
        {({ onItemsRendered, ref }) => (
          <FixedSizeList
            height={400}
            width={300}
            itemSize={46}
            itemCount={itemCount}
            onItemsRendered={onItemsRendered}
            ref={ref}
          >
            {({ index, style }) => (
              <ListItem
                button
                style={style}
                key={index}
                onClick={() => handleClick(index)}
              >
                <ListItemText
                  primary={
                    isItemLoaded(index) ? items[index].name : 'loading ...'
                  }
                />
              </ListItem>
            )}
          </FixedSizeList>
        )}
      </InfiniteLoader>
    </Dialog>
  );
};

export default CustomerListDialog;
